import { render, staticRenderFns } from "./ShoppingCartConnectRoom.vue?vue&type=template&id=0b218313&scoped=true"
import script from "./ShoppingCartConnectRoom.vue?vue&type=script&lang=js"
export * from "./ShoppingCartConnectRoom.vue?vue&type=script&lang=js"
import style0 from "./ShoppingCartConnectRoom.vue?vue&type=style&index=0&id=0b218313&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b218313",
  null
  
)

export default component.exports